import React, {useMemo} from 'react';
import BrandFilterTab from '@/_application/modules/categories/components/sorting-filter-toolbar/sorting-filter/filter/components/brand-filter-tab';
import {Image} from '@/_application/core/components/ui/image';
import {getImageAssetUrl} from '@/_application/core/utils/common';
import {BrandByLetterType} from '@/_application/modules/categories/components/sorting-filter-toolbar/sorting-filter-toolbar.type';
import {Aggregation} from '@/__generated__/__types__';
import {ORDER_DOCS} from '@/framework/static/filter-attribute-code-value-type';

const GraySearch = getImageAssetUrl('icons/gray-search.png');

interface FilterByBrandProps {
    aggregationList: Aggregation[];
    brandSearchInput: string;
    query: Record<string, any>;
    onQueryChange: (attribute_code: string, buttonValue: string, isSelected: boolean) => void;
    onBrandSearchInputChange: (value: string) => void;
}

const FilterByBrand: React.FC<FilterByBrandProps> = ({
    query,
    aggregationList,
    brandSearchInput,
    onQueryChange,
    onBrandSearchInputChange,
}) => {
    const brandAggregation = useMemo(() => {
        return aggregationList.find((item: any) => item.attribute_code === 'brand');
    }, [JSON.stringify(aggregationList)]);

    //: Handle
    if (!brandAggregation?.options?.length) {
        return <></>;
    }

    const brandByLetter: BrandByLetterType[] = useMemo(() => {
        const listBrandByFirstCharacter: BrandByLetterType[] = [];
        const brandList = brandAggregation.options?.filter(brand =>
            brand?.label?.toLowerCase().includes(brandSearchInput),
        );
        brandList?.forEach(brand => {
            if (!brand) {
                return;
            }

            if (brand?.value === ORDER_DOCS) {
                return;
            }

            const firstLetter = brand?.label?.charAt(0);
            const index = listBrandByFirstCharacter.findIndex(item => item.id === firstLetter);
            if (index < 0) {
                listBrandByFirstCharacter.push({
                    id: `${firstLetter}`,
                    data: [brand],
                });
            } else {
                listBrandByFirstCharacter[index].data.push(brand);
            }
        });

        return listBrandByFirstCharacter;
    }, [JSON.stringify(aggregationList), brandSearchInput]);

    const selectBrand = (brandValue: string, isChecked: boolean) => {
        onQueryChange('brand', brandValue, isChecked);
    };

    return (
        <div className="relative mx-auto flex w-full flex-col items-center justify-center">
            <div className="mb-6 w-full bg-white px-4">
                <div className="flex w-full items-center justify-self-auto rounded-2xl border border-gray-300">
                    <div className="ml-2 flex items-center justify-center pr-2">
                        <Image src={GraySearch} alt="search icon" height={19} width={19} />
                    </div>

                    <input
                        value={brandSearchInput}
                        onChange={value => onBrandSearchInputChange(value.target.value)}
                        placeholder="Tìm thương hiệu"
                        className="h-8 w-[95%] overflow-hidden text-ellipsis rounded-r-2xl border-none text-xs focus:outline-none"
                        aria-label="Tìm thương hiệu"
                    />
                </div>
            </div>

            <BrandFilterTab data={brandByLetter} query={query['brand']} onChange={selectBrand} />
        </div>
    );
};

export default FilterByBrand;
